import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link/Link';
import App from '../../assets/icons/DIGID_Iconen_App.svg';
import ID from '../../assets/icons/DIGID_Iconen-ID.svg';
import SMS from '../../assets/icons/DIGID_Iconen-SMS.svg';
import User from '../../assets/icons/DIGID_Iconen-Username.svg';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

const InfoBlock = ({ title, smalltext, text, blocks, layout }) => {

  const { t } = useTranslation();

  return (
    <div className="info-section">
      <h2>{title}</h2>
      { smalltext && <p className="small-text">{smalltext}</p>}
      <p className="intro-text">{text}</p>
      <div className={`info-blocks ${layout}`}>
        {blocks &&
          blocks.map((block, i) => {
            let icon = '';
            switch (block.icon) {
              case 'app':
                icon = <App />;
                break;
              case 'id':
                icon = <ID />;
                break;
              case 'sms':
                icon = <SMS />;
                break;
              case 'user':
                icon = <User />;
                break;
              default:
                icon = (<img src={block.icon} alt={block.title} className={cn(block.extraClassName)} />);
            }

            let hasUrl = block.url || block.url === null;
            let title = block.title;
            let titleEl = (<h6>{block.title}</h6>);

            if (hasUrl) {
              titleEl = (<h6 className="title-link">{block.title}</h6>);
            }

            return (
              <div key={i} className="block">
                <div className="text-wrapper">
                  {hasUrl ? (
                    <Link className="no-margin inherit-color" href={block.url} target={block.target} label={block.linkLabel || null}>{titleEl}</Link>
                  ) : titleEl}

                  <p>{block.text}</p>

                  {hasUrl && (<Link type="arrow" href={block.url} target={block.target}  aria-label={t('read_more_about', { title })} label={block.linkLabel}>
                    {block.moreLinkLabel || 'Meer informatie'}
                  </Link>)}
                </div>

                <div className="icon-wrapper">
                  {hasUrl ? (
                    <Link href={block.url} target={block.target} label={block.linkLabel}>{icon}</Link>
                  ) : icon}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

InfoBlock.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  smalltext: PropTypes.string,
  layout: PropTypes.oneOf(['half-size', 'full-size']),
  blocks: PropTypes.arrayOf(PropTypes.object),
};

InfoBlock.defaultProps = {
  title: 'Informatie over inlogmethodes',
  smalltext: '',
  text: 'Voeg meer inlogmiddelen toe en regel meer met uw DigiD.',
  layout: 'half-size',
  blocks: [
    {
      icon: 'app',
      title: 'DigiD-app',
      text: 'De makkelijkste manier om in te loggen',
      url: '',
      target: '',
    },
    {
      icon: 'sms',
      title: 'Sms-controle',
      text: 'Inloggen met extra sms-controle',
      url: '',
      target: '',
    },
    {
      icon: 'user',
      title: 'Gebruikersnaam en wachtwoord',
      text: 'Inloggen met gebruikersnaam en wachtwoord',
      url: '',
      target: '',
    },
    {
      icon: 'id',
      title: 'Paspoort, rijbewijs of identiteitskaart',
      text: 'Alleen als u een rijbewijs heeft na 1 mei 2018',
      url: '',
      target: '',
    },
  ],
};

export default InfoBlock;
